import { Divider, Drawer, Input, Space, Form, Checkbox, Tooltip, Modal } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import ImageSelect from "../../ImageSelect";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import { previewLink, tt_name_block_warning, tt_padding_x, tt_padding_y } from "../../../utils/Utils";
import { fetchImage } from "../../../utils/Api";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { useTemplate } from "../../../utils/Template";
import { getColor } from "../../../utils/ConvertCSS";
import SliderInput from "../../UI/SiderInput";
import LinkUI from "../../UI/LinkUI";

const ImageGif = React.memo((props) => {
    const [template, ] = useTemplate();
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        background_colour = 0,
        image = "",
        alt = "",
        align = "left",
        link = "",
        new_tab = true,
        padding_x = 0,
        padding_y = 0,
        width = 1248,
        has_width = false,
        image_radius = 0
    } = data;



    const save = () => {

        if(!name){
            let _name = prompt(tt_name_block_warning);
            if(_name){
                close();
                saveItem(id, { ...content, "name" : _name });
            } else {
                return; 
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }


    const WrapLink = (props) => {
        if (link) {
            return <a href={previewLink(link)} target={(new_tab) ? "_blank" : "_self"}>{props.children}</a>
        } else {
            return props.children;
        }
    }

    const drawRender = () => {

        let _style = {
            padding: padding_y + "px " + padding_x + "px",
            maxWidth: (has_width) ? width + "px" : "100%"
        }

        let _img_style = {
            maxWidth: "100%",
            borderRadius : image_radius+"px"
        }

        let _align = {
            background: getColor(background_colour, template),
            display: "flex",
            flexDirection: "column",
        }

        switch (align) {
            case "center":
                _style.alignSelf = "center";
                break;
            case "right":
                _style.alignSelf = "flex-end";
                break;
            default:
                _style.alignSelf = "flex-start";
                break;
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_align}>
                    <div style={_style}>
                        <div className={(link) ? "bm-img-link" : ""}>
                            {(image && <WrapLink><img alt={alt} style={_img_style} src={fetchImage(image)} /></WrapLink>)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />

                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />

                {/* IMAGE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE / GIF</Divider>
                <ImageSelect require_alt alt={alt} onChange={(_v, _alt) => setData({ ...data, "image": _v, "alt" : _alt })} width={235} path={image} />
                <div className="shim" />
                <BMInput allow_update value={alt} onChange={(e) => setData({...data, "alt": e})} prefix_width={"50px"} prefix={<nobr>ALT TEXT &nbsp;</nobr>} width={"190px"} placeholder={"Describe the image..."} />
                <div className="shim" /><div className="shim" />
                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH</Divider>

                <div className="float-flex">

                <SliderInput
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "width": _v })}
                        disabled={!has_width}
                        value={width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "has_width": e.target.checked })} checked={has_width}><small>Constrain?</small></Checkbox>
                </div>

                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / BORDER RADIUS</Divider>
                <Space>
                    <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    <BMInput width={"40px"} value={image_radius} onChange={(e) => setData({ ...data, "image_radius": e })} number min={0} max={1000} prefix="RADIUS" />
                </Space>
                <div className="shim" /> <div className="shim" />

                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                <div className="float-flex">
                    <Space>
                        <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "left" })} style={{ "color": (align === "left") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "center" })} style={{ "color": (align === "center") ? "#1890ff" : "#AAA" }} /></div>
                        <div><PicRightOutlined onClick={() => setData({ ...data, "align": "right" })} style={{ "color": (align === "right") ? "#1890ff" : "#AAA" }} /></div>
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* LINK  */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK</Divider>

                <LinkUI value={link} onChange={(e) => setData({ ...data, "link": e })} />
                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                <div style={{ "marginTop": "-15px" }} className="float-flex">
                    <div>&nbsp;</div>
                    <Checkbox disabled={(!link)} checked={new_tab} onChange={(e) => setData({ ...data, "new_tab": e.target.checked })} ><small>Open in new tab?</small></Checkbox>
                </div>

            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

});
export default ImageGif; 